/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc
 */

export const getRevisionsRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc',
  rpcName: 'getRevisions',
  auth: 'app',
  fingerprint: 'PWmoqDgN2yMWFv1WPlUwPt4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRevisionRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc',
  rpcName: 'getRevision',
  auth: 'app',
  fingerprint: '59vo5yOlkePGK03a8xjLN94p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreRevisionRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc',
  rpcName: 'restoreRevision',
  auth: 'app',
  fingerprint: 'KP29qzoQgq0y8-0IDaLacN4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};